define([
	'internal_util/Logger',
	'internal_util/Util',
	'model/Terminal',
	'model/Card',
	'service/EventListenerRegistry',
	'service/TerminalManager',
	'amdi18n-loader?!service/nls/EidClientEventManager_strings'
], function (
	Logger,
	Util,
	Terminal,
	Card,
	EventListenerRegistry,
	TerminalManager,
	Strings
) {
	'use strict';

	/**
	 * EidClientEventManager class
	 */
	return function () {
		var _terminalManager = new TerminalManager();


		// private methods

		function log(method, message, data) {
			Logger.log('EidClientEventManager', method, message, data);
		}

		function addTerminal(data) {
			var _name = 'addTerminal',
				terminal = null;

			try {
				terminal = new Terminal(data.id, data.name, data.contextHandle);

				log(_name, Strings.terminal_added, terminal);

				_terminalManager.addTerminal(terminal);
			} catch (error) {
				log(_name, Strings.terminal_not_created, error);
			}

			return terminal;
		}

		function removeTerminal(data) {
			var terminal = _terminalManager.removeTerminal(data.id);

			if (terminal !== null) {
				log('removeTerminal', Strings.terminal_removed, terminal);
			}

			return terminal;
		}

		function addCard(data) {
			var _name = 'addCard',
				terminal = _terminalManager.getTerminal(data.terminalId),
				card,
				cardTerminal;

			if (terminal !== null) {
				try {
					card = new Card(data.id, data.type, data.slot);

					cardTerminal = { terminal : terminal, card : card };

					log(_name, Strings.card_added, cardTerminal);

					terminal.addCard(card);

					return cardTerminal;
				} catch (error) {
					log(_name, Strings.card_not_created, error);
				}
			}

			return null;
		}

		function removeCard(data) {
			var terminal = _terminalManager.getTerminal(data.terminalId),
				card,
				cardTerminal;

			if (terminal !== null) {
				card = terminal.removeCard(data.id);

				if (card !== null) {
					cardTerminal = { terminal : terminal, card : card };

					log('removeCard', Strings.card_removed, cardTerminal);

					return cardTerminal;
				}
			}

			return null;
		}

		function updateCard(data) {
			var oldCardTerminal = removeCard(data),
				cardTerminal = addCard(data);

			if (cardTerminal !== null) {
				log('updateCard', Strings.card_updated, { old : oldCardTerminal, 'new' : cardTerminal});
			}

			return cardTerminal;
		}


		// public methods

		this.handleEvent = function (event) {
			var data = null;

			switch (event.type) {
			case 'TERMINAL_ADDED':
				data = addTerminal(event.data);
				break;
			case 'TERMINAL_REMOVED':
				data = removeTerminal(event.data);
				break;
			case 'CARD_INSERTED':
				data = addCard(event.data);
				break;
			case 'CARD_RECOGNIZED':
				data = updateCard(event.data);
				break;
			case 'CARD_REMOVED':
				data = removeCard(event.data);
				break;
			default:
				log('handleEvent', Strings.invalid_event, event);
			}

			if (data !== null) {
				EventListenerRegistry.callListeners(event.type, data);
			}
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/EidClientEventManager.js
// module id = 155
// module chunks = 4